import { TYPES } from '@model/utils/types';
import { Type } from './Type';

export class Json extends Type {
    static getDefault() {
        return {};
    }

    static toValue(value: any): { [key: string]: any } {
        if (typeof value !== 'string') {
            return value;
        }

        return JSON.parse(value);
    }
}

Json[TYPES.TYPE] = 'json';
